import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const DiscoverStepThreeExtraCollections = ({
  discoverStepThreeExtraCollections,
  discoverStepThreeExtraCurrency,
  getCollections,
  hasLoaded,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="discover-collections-container--step-three-extra"
      currency={discoverStepThreeExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={discoverStepThreeExtraCollections}
      levelsPath={paths.DISCOVER_STEP_THREE_EXTRA_LEVELS}
      student={student}
      title={messages.game.discover}
    />
  );
};

DiscoverStepThreeExtraCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  discoverStepThreeExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  discoverStepThreeExtraCurrency: PropTypes.shape({}).isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.discoverStepThreeExtraCollections.getHasLoaded(state),
  discoverStepThreeExtraCollections: selectors.discoverStepThreeExtraCollections.getCollectionsData(
    state
  ),
  discoverStepThreeExtraCurrency: selectors.discoverStepThreeExtraCollections.getCurrencyData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.discoverStepThreeExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(DiscoverStepThreeExtraCollections);
